import React, { useState, useEffect, useRef } from 'react';
import './LogoPreloader.css';

const LogoPreloader = () => {
  const [loading, setLoading] = useState(true);
  const [fading, setFading] = useState(false);
  const videoRef = useRef(null);
  const finishedRef = useRef(false);

  const finishLoading = () => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    setFading(true);
    setTimeout(() => {
      setLoading(false);
      document.body.style.overflow = '';
      if (document.documentElement) document.documentElement.style.overflow = '';
    }, 2200);
  };

  const isAdminPath = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdminPath) {
      setLoading(false);
      return;
    }

    // Lock scroll while preloader is active
    document.body.style.overflow = 'hidden';
    if (document.documentElement) document.documentElement.style.overflow = 'hidden';

    // Ensure video plays smoothly from beginning
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => {
        // Auto-play policy handler
      });
    }

    // Extended safety fallback timer (15 seconds) so video is NEVER cut short
    const fallbackTimer = setTimeout(() => {
      finishLoading();
    }, 15000);

    return () => {
      clearTimeout(fallbackTimer);
      document.body.style.overflow = '';
      if (document.documentElement) document.documentElement.style.overflow = '';
    };
  }, [isAdminPath]);

  const handleTimeUpdate = () => {
    if (videoRef.current && videoRef.current.duration) {
      const remaining = videoRef.current.duration - videoRef.current.currentTime;
      if (remaining <= 1.2) {
        finishLoading();
      }
    }
  };

  const handleEnded = () => {
    finishLoading();
  };

  if (!loading || isAdminPath) return null;

  const videoUrl = process.env.PUBLIC_URL + '/Logo Animation.mp4';

  return (
    <div className={`logo-preloader-overlay ${fading ? 'fade-out' : ''}`}>
      <div className="logo-preloader-container">
        <video
          ref={videoRef}
          src={videoUrl}
          autoPlay
          muted
          playsInline
          preload="auto"
          onTimeUpdate={handleTimeUpdate}
          onEnded={handleEnded}
          className="preloader-video"
        />
      </div>
    </div>
  );
};

export default LogoPreloader;
